import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'details-location',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './location.component.html',
  styleUrl: './location.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DetailsLocationComponent {
    public location: InputSignal<any> = input.required<any>();

    handleClick(){
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${this.location().lat},${this.location().lng}`
      window.open(googleMapsUrl, "_blank");
    }

}